export const guitarSetups = {
  GCEA: [55, [5, 4, 5]],
  EADG: [28, [5, 5, 5]],
  BEADG: [23, [5, 5, 5, 5]],
  EADGBE: [40, [5, 5, 5, 4, 5]],
  EADGCF: [40, [5, 5, 5, 5, 5]],
  CGDAEG: [36, [7, 7, 7, 7, 3]],
  AbEbBbFCG: [32, [7, 7, 7, 7, 7]],
  BEADGBE: [35, [5, 5, 5, 5, 4, 5]],
  FsBEADGBE: [30, [5, 5, 5, 5, 5, 4, 5]],
  EBEADGBE: [28, [7, 5, 5, 5, 5, 4, 5]],
  DADGBE: [38, [7, 5, 5, 4, 5]],
  DADGBD: [38, [7, 5, 5, 4, 3]],
  DADGAD: [38, [7, 5, 5, 2, 7]],
  DADFsAD: [38, [7, 5, 4, 3, 5]], // open D
  DGDGBD: [38, [5, 7, 5, 4, 3]], // open G
  custom: [],
};

export const selectNpsValues = [
  "auto",
  "3nps",
  "4nps",
  "2nps",
  "1nps",
  "3:1:3",
  "2:1:2",
  "2:1:1:1:1:2",
  "2:1:1:1:2",
  "3:2:3",
];


// Preserve the pitches of charts made before the Double Drop D correction.
export const isLegacyDoubleDropD = (setup, tuning) =>
  setup === "DADGBD" && JSON.stringify(tuning) === "[7,5,5,4,5]";
